import React, { useState, useEffect } from "react";
// import axios from "axios";
import versityOne from "../../../asset/images/versity_img11.jpg";
import "./Carousel.css";

const Carousel = () => {
  // Static dates - commented out API call to database
  const staticDates = {
    PaperSubmissionDeadline: "7th December 2025",
    AcceptanceNotification: "14th December 2025",
    RegistrationDeadline: "23th December 2025",
    CameraReadySubmission: "15 May 2026"
  };

  // const [date, setDate] = useState(null);
  // const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/get-date`
  //       );
  //       setDate(response.data);
  //     } catch (error) {
  //       console.error("Error fetching date data", error);
  //       setError(error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // if (error) {
  //   return <div>Error loading data!</div>;
  // }

  // if (!date) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div id="carouselExample" className="carousel slide" data-bs-ride="carousel">
      {/* Title */}
      <div className="carousel-title">
        <span className="text-background">
          2<sup>nd</sup> International Conference on Engineering and Technology for Sustainable Development (ETSD 2026)
        </span>
      </div>

      <div className="carousel-inner">
        <div className="carousel-item active">
          <img
            src={versityOne}
            className="d-block w-100"
            alt="Conference Background"
          />
          <div className="carousel-caption">
            <div className="deadlines-grid">
              <div className="deadline-item">
                <span>Abstract Submission Deadline:</span>
                <strong className="text-info">{staticDates.PaperSubmissionDeadline}</strong>
              </div>
              <div className="deadline-item">
                <span>Notification of Acceptance:</span>
                <strong className="text-info">{staticDates.AcceptanceNotification}</strong>
              </div>
              <div className="deadline-item">
                <span>Registration Deadline:</span>
                <strong className="text-info">{staticDates.RegistrationDeadline}</strong>
              </div>
              <div className="deadline-item">
                <span>Conference Dates:</span>
                <strong className="text-info">{staticDates.CameraReadySubmission}</strong>
              </div>
            </div>
            
            <div className="venue-home-container mt-4">
              <div className="deadline-item">
                <span>Conference Venue:</span>
                <strong className="text-info d-block mt-1">
                  Jashore University of Science and Technology Campus, Bangladesh
                </strong>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="homeBtn"
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/1Pj-YwsJo4Ev_YVxL8lvAPNapBtUB7nUA/view?usp=sharing"
                  )
                }
              >
                Call For Paper
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;